import Api from '/core/services/Api';

export const loginOneUser = async(obj) => {
    try {
      const response = await Api.post(`login`, obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const logoutOneUser = async() => {
    try {
      const response = await Api.get(`logout`);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const forgotOneUserPassword = async(obj) => {
    try {
      const response = await Api.post(`forgot-password`,obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const checkOneUserResetCode = async(c) => {
    try {
      const response = await Api.get(`check-reset-code/`+c);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const updateUserPassword = async(hash, obj) => {
    try {
      const response = await Api.put(`update-user-password/`+hash, obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchCertifcateByHash = async(hash) => {
    try {
      const response = await Api.get(`certificate/authentication/`+hash);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchPricingAgreementByHash = async(hash) => {
    try {
      const response = await Api.get(`pricing-agreement/`+hash);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const updatePricingAgreementByHash = async(hash, obj) => {
    try {
      const response = await Api.put(`pricing-agreement/`+hash, obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchMOUByHash = async(hash) => {
    try {
      const response = await Api.get(`mou/`+hash);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const updateMOUByHash = async(hash, obj) => {
    try {
      const response = await Api.put(`mou/`+hash, obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const checkAccountExists = async(obj) => {
    try {
      const response = await Api.post(`email-account`, obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const checkTicketExists = async(h) => {
    try {
      const response = await Api.get(`tickets/`+h);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};